<template>
  <v-content>
    <v-container fluid>
      <iframe
        v-if="dashUrl"
        :src="dashUrl"
        allowtransparency
        frameborder="0"
        @load="frameLoaded"
      ></iframe>
      <!--width="800"
        height="600" 
        frameborder="0"
        allowtransparency-->
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
export default {
  name: "Dashboard",
  components: {},
  data: () => ({
    dashUrl: null,
  }),
  created() {
    this.loadData(this.$route.params.id);
  },
  methods: {
    frameLoaded: function () {
      window.iFrameResize({}, "iframe");
    },
    loadData: function (dashId) {
      api
        .getDashboard(dashId)
        .then((resp) => {
          this.dashUrl = resp.data.url;
        })
        .catch((err) => {
          this.$emit("error", true);
        });
    },
  },
  watch: {
    $route() {
      // params cotains the current route parameters
      this.loadData(this.$route.params.id);
    },
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
}
</style>
